<template>
  <div class="inspectionUseInformation table-responsive col-12">
    <li
      v-if="headerShow == true"
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      檢驗數值
    </li>
    <b-row
      v-if="!inspectionUseSingleProcess"
      class="mx-0 text-center"
      style="margin-top: 1rem; margin-bottom: 0.7rem"
    >
      <template v-if="inspectionUseInformationData.length == 0">
        <div
          style="
            width: 140px;
            margin-right: 0.2rem;
            border-bottom: 0.6rem #427ace solid;
            padding: 0.5rem 1rem 0 1rem;
            background-color: transparent;
            color: #427ace;
            font-size: 1rem;
            font-family: dfyuanstd-w5, dfyuanstd-w3;
            cursor: pointer;
          "
          @click="process_insp_select_default = 5"
          :class="{
            'inspectionProcess-heading-active': process_insp_select_default == 5
          }"
        >
          打頭
        </div>
        <div
          style="
            width: 140px;
            margin-right: 0.2rem;
            border-bottom: 0.6rem #009245 solid;
            padding: 0.5rem 1rem 0 1rem;
            background-color: transparent;
            color: #009245;
            font-size: 1rem;
            font-family: dfyuanstd-w5, dfyuanstd-w3;
            cursor: pointer;
          "
          @click="process_insp_select_default = 6"
          :class="{
            'inspectionProcess-thread-active': process_insp_select_default == 6
          }"
        >
          輾牙
        </div>
      </template>
      <div
        v-for="(item, index) in inspectionUseInformationData"
        :key="index"
        style="
          width: 140px;
          margin-right: 0.2rem;
          border-bottom: 0.6rem solid;
          padding: 0.5rem 1rem 0 1rem;
          background-color: transparent;
          font-size: 1rem;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          cursor: pointer;
        "
        :style="{
          color:
            item.process_id == 5
              ? '#427ace'
              : item.process_id == 6 && !item.rework
              ? '#009245'
              : '#ff6b00',
          'border-color':
            item.process_id == 5
              ? '#427ace'
              : item.process_id == 6 && !item.rework
              ? '#009245'
              : '#ff6b00'
        }"
        @click="process_insp_select = index"
        :class="{
          'inspectionProcess-heading-active':
            process_insp_select == index && item.process_id == 5,
          'inspectionProcess-thread-active':
            process_insp_select == index && item.process_id == 6,
          'inspectionProcess-HeatTreatment-active':
            process_insp_select == index && item.process_id == 6 && item.rework
        }"
      >
        {{ item.process_id == 5 ? "打頭" : item.process_id == 6 ? "輾牙" : "" }}
        {{ item.rework ? "(重工)" : "" }}
      </div>
    </b-row>
    <b-tabs class="customize-tab text-center mb-2" v-model="tabIndex">
      <b-tab title="首件檢查" active class="" style="margin-top: 2.125rem">
        <template v-if="inspection_data.first.nth.length == 0">
          <b-row class="mx-0 text-left">
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第1支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第2支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-row class="mx-0 text-left">
            <b-col
              v-for="(item, key) in inspection_data.first.data[
                inspection_data.first.nth[0]
              ]"
              :key="key"
              cols="12"
              class="text-left mt-3"
            >
              <p class="mb-0">第{{ key + 1 }}支工件</p>
              <b-table
                :items="item.inspection"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
                <template #cell(time)="row">
                  {{ row.value.split(".")[0] }}
                </template>
                <template #cell(inspectionValue)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["inspectionValue"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["inspectionValue"] }}
                  </template>
                </template>
                <template #cell(result)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["result"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["result"] }}
                  </template>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </template>
      </b-tab>
      <b-tab title="自主檢查" class="">
        <template v-if="inspection_data.self.nth.length == 0">
          <b-row class="mx-0 text-left" style="margin-top: 2.125rem">
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第1支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第2支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-col cols="12" class="text-left mt-1">
            <b-button
              v-for="(item, key) in inspection_data.self.nth"
              :key="key"
              class="mr-2 mb-1"
              :class="{ active: button_select == item }"
              @click="button_select = item"
              >{{ item }}
            </b-button>
          </b-col>
          <b-row class="mx-0 text-left">
            <b-col
              v-for="(item, key) in inspection_data.self.data[button_select]"
              :key="key"
              cols="12"
              class="text-left mt-3"
            >
              <p class="mb-0">第{{ key + 1 }}支工件</p>
              <b-table
                :items="item.inspection"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
                <template #cell(time)="row">
                  {{ row.value.split(".")[0] }}
                </template>
                <template #cell(inspectionValue)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["inspectionValue"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["inspectionValue"] }}
                  </template>
                </template>
                <template #cell(result)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["result"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["result"] }}
                  </template>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </template>
      </b-tab>
      <b-tab title="末件檢查" class="" style="margin-top: 2.125rem">
        <template v-if="inspection_data.last.nth.length == 0">
          <b-row class="mx-0 text-left">
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第1支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
            <b-col cols="12" class="text-left mt-3">
              <p class="mb-0">第2支工件</p>
              <b-table
                :items="[]"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
              </b-table>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-row class="mx-0 text-left">
            <b-col
              v-for="(item, key) in inspection_data.last.data[
                inspection_data.last.nth[inspection_data.last.nth.length - 1]
              ]"
              :key="key"
              cols="12"
              class="text-left mt-3"
            >
              <p class="mb-0">第{{ key + 1 }}支工件</p>
              <b-table
                :items="item.inspection"
                :fields="inspectionUseInformationFields"
                sticky-header="186px"
                :no-border-collapse="noBorderCollapse"
                class="text-center inspectionUseInformation-table-detail mb-2"
              >
                <template #cell(time)="row">
                  {{ row.value.split(".")[0] }}
                </template>
                <template #cell(inspectionValue)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["inspectionValue"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["inspectionValue"] }}
                  </template>
                </template>
                <template #cell(result)="row">
                  <template v-if="row.item['result'] == 'NG'">
                    <b style="color: red">{{ row.item["result"] }}</b>
                  </template>
                  <template v-else>
                    {{ row.item["result"] }}
                  </template>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "inspectionUseInformation",
  props: {
    headerShow: {
      type: String,
      default: true
    }
  },
  data() {
    return {
      inspection_data: {
        first: { nth: [], data: {} },
        self: { nth: [], data: {} },
        last: { nth: [], data: {} }
      },
      process_insp_select_default: 5,
      process_insp_select: 0,
      button_select: 1,
      tabIndex: 1,
      noBorderCollapse: true
    };
  },
  created: function() {
    // this.getSelectProject();
    // this.setFirstInspection();
    let vm = this;
    vm.setInspection();
  },
  mounted: function() {},
  watch: {
    inspectionUseInformationData: {
      handler() {
        let vm = this;
        vm.setInspection();
      },
      deep: true
    },
    process_insp_select: {
      handler() {
        let vm = this;
        if (
          vm.inspectionUseInformationData[vm.process_insp_select]["data"] !=
          undefined
        ) {
          vm.changeInspectionData();
          if (vm.inspection_data.self.data[vm.button_select] == undefined) {
            vm.button_select =
              vm.inspection_data.self.nth[
                vm.inspection_data.self.nth.length - 1
              ];
          }
        } else {
          vm.emptyInspectionData();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      inspectionUseInformationFields:
        "inspectionUseInformation/get_inspectionUseInformationFields",
      inspectionUseInformationData:
        "inspectionUseInformation/get_inspectionUseInformationData",
      inspectionUseSingleProcess:
        "inspectionUseInformation/get_inspectionUseSingleProcess"
    })
  },
  methods: {
    setInspection() {
      let vm = this;
      if (vm.inspectionUseInformationData == "") {
        vm.emptyInspectionData();
        return;
      }
      if (vm.inspectionUseSingleProcess) {
        if (vm.inspectionUseInformationData["first"] != undefined) {
          vm.inspection_data.first = {
            nth: Object.keys(vm.inspectionUseInformationData["first"]),
            data: vm.inspectionUseInformationData["first"]
          };
        } else {
          vm.inspection_data.first = {
            nth: [],
            data: {}
          };
        }
        if (vm.inspectionUseInformationData["self"] != undefined) {
          vm.inspection_data.self = {
            nth: Object.keys(vm.inspectionUseInformationData["self"]),
            data: vm.inspectionUseInformationData["self"]
          };
        } else {
          vm.inspection_data.self = {
            nth: [],
            data: {}
          };
        }
        if (vm.inspectionUseInformationData["last"] != undefined) {
          vm.inspection_data.last = {
            nth: Object.keys(vm.inspectionUseInformationData["last"]),
            data: vm.inspectionUseInformationData["last"]
          };
        } else {
          vm.inspection_data.last = {
            nth: [],
            data: {}
          };
        }
      } else {
        let total_inspection_process = Object.keys(
          vm.inspectionUseInformationData
        );
        if (total_inspection_process.length == 0) {
          vm.process_insp_select = 0;
        } else {
          vm.process_insp_select = total_inspection_process[0];
        }
        if (
          vm.inspectionUseInformationData[vm.process_insp_select] == undefined
        ) {
          vm.emptyInspectionData();
          return;
        }
        if (
          vm.inspectionUseInformationData[vm.process_insp_select]["data"] ==
          undefined
        ) {
          vm.emptyInspectionData();
          return;
        } else {
          vm.changeInspectionData();
        }
      }
    },
    changeInspectionData() {
      let vm = this;
      vm.inspectionUseInformationData[vm.process_insp_select]["data"];
      if (
        vm.inspectionUseInformationData[vm.process_insp_select]["data"][
          "first"
        ] != undefined
      ) {
        vm.inspection_data.first = {
          nth: Object.keys(
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "first"
            ]
          ),
          data:
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "first"
            ]
        };
      } else {
        vm.inspection_data.first = {
          nth: [],
          data: {}
        };
      }
      if (
        vm.inspectionUseInformationData[vm.process_insp_select]["data"][
          "self"
        ] != undefined
      ) {
        vm.inspection_data.self = {
          nth: Object.keys(
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "self"
            ]
          ),
          data:
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "self"
            ]
        };
      } else {
        vm.inspection_data.self = {
          nth: [],
          data: {}
        };
      }
      if (
        vm.inspectionUseInformationData[vm.process_insp_select]["data"][
          "last"
        ] != undefined
      ) {
        vm.inspection_data.last = {
          nth: Object.keys(
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "last"
            ]
          ),
          data:
            vm.inspectionUseInformationData[vm.process_insp_select]["data"][
              "last"
            ]
        };
      } else {
        vm.inspection_data.last = {
          nth: [],
          data: {}
        };
      }
    },
    emptyInspectionData() {
      let vm = this;
      vm.inspection_data.first = {
        nth: [],
        data: {}
      };
      vm.inspection_data.self = {
        nth: [],
        data: {}
      };
      vm.inspection_data.last = {
        nth: [],
        data: {}
      };
    }
  }
};
</script>

<style lang="scss">
.inspectionProcess-heading-active {
  background-color: #427ace !important;
  color: #ffffff !important;
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
}
.inspectionProcess-thread-active {
  background-color: #009245 !important;
  color: #ffffff !important;
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
}
.inspectionProcess-HeatTreatment-active {
  background-color: #ff6b00 !important;
  color: #ffffff !important;
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
}
.nav-tabs .nav-link {
  width: 140px;
  margin-right: 0.5rem;
  border-radius: 0.75rem 0.75rem 0 0;
}
.nav-tabs .nav-link.active,
.nav-tabs .show > .nav-link {
  background-color: #4b8c80;
  color: #ffffff;
}
.nav-tabs .nav-link,
.nav-tabs .show > .nav-link {
  background-color: #999999;
  color: #ffffff;
}
.nav-tabs > .nav-item > a {
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
}
.nav-tabs {
  border-bottom: none;
}
.inspectionUseInformation .customize-tab {
  background-color: #ffffff;
}
.inspectionUseInformation .customize-tab > div:nth-child(1) {
  background-color: #f2f2f2;
}
.inspectionUseInformation .btn {
  height: 2rem;
  line-height: 2rem;
  padding: 0px;
  width: 4.25rem;
}
.inspectionUseInformation .btn.active {
  background-color: #4b8c80 !important;
  border-color: #4b8c80 !important;
}

.inspectionUseInformation-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.inspectionUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.inspectionUseInformation-table-detail th,
.inspectionUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.inspectionUseInformation-table-detail th:first-child,
.inspectionUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.inspectionUseInformation-table-detail {
  margin-bottom: 0px;
}
.inspectionUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/inspectionUseInformation.vue